import { Route } from 'react-router-dom';
import CampaignsPage from './pages/CampaignsPage';

export const CampaignsRoutes = [
  <Route key="campaigns" path="/dashboard/campaigns" element={<CampaignsPage />} />
];